import VideoReviewsScope from '@/enums/VideoReviewsScope';
import ReviewAuthorDisplayType from '@/enums/ReviewAuthorDisplayType';

const state = {
  reviewSettings: null,
  reviewPromptSettings: null,
  laboratorySettings: null
};

const getters = {
  isVideoUploadable({ reviewSettings }) {
    return (
      reviewSettings.video_reviews_scope === VideoReviewsScope.ADMIN_AND_POPUP
    );
  },
  isAuthorDisplayTypeUserGrade({ reviewSettings }) {
    return (
      reviewSettings.author_display_type === ReviewAuthorDisplayType.USER_GRADE
    );
  },
  isAuthorDisplayTypeAuthorType({ reviewSettings }) {
    return (
      reviewSettings.author_display_type === ReviewAuthorDisplayType.AUTHOR_TYPE
    );
  }
};

const mutations = {
  SET_REVIEW_SETTINGS(state, reviewSettings) {
    state.reviewSettings = reviewSettings;
  },
  SET_REVIEW_PROMPT_SETTINGS(state, reviewPromptSettings) {
    state.reviewPromptSettings = reviewPromptSettings;
  },
  SET_LABORATORY_SETTINGS(state, laboratorySettings) {
    state.laboratorySettings = laboratorySettings;
  }
};

const actions = {
  fetchReviewSettings({ rootState, commit }, isMobile) {
    return rootState.api.fetchReviewSettings(isMobile).then(({ data }) => {
      commit('SET_REVIEW_SETTINGS', data.review_settings);
      commit('SET_REVIEW_PROMPT_SETTINGS', data.review_prompt_settings);
      commit('SET_LABORATORY_SETTINGS', data.laboratory_settings);
    });
  }
};

export default { namespaced: true, state, getters, mutations, actions };
